import React from 'react'
import Layout from '../Layout'
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { makeStyles } from '@material-ui/core/styles'
import Static from '../Static'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '100%',
        flexShrink: 0,
        marginBottom: 0,
        padding: '8px',
        color: '#000',
        fontWeight: 500,
    },
}))

export default function faq(props) {
    const baseStyle = {
        fontWeight: 700,
        marginBottom: '12px',
    }

    const h1Style = {
        ...baseStyle,
        marginTop: '32px',
        marginBottomss: '32px',
        // Additional or overriding styles for h2 can go here if needed
    }

    const h4Style = {
        ...baseStyle,
        marginTop: '20px',
        marginBottom: '20px',
        // Additional or overriding styles for h4 can go here if needed
    }
    const classes = useStyles()
    const [expandedParent, setExpandedParent] = React.useState(false)
    const [expanded, setExpanded] = React.useState(false)

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false)
    }

    const handleParentChange = (panel) => (event, isExpanded) => {
        setExpandedParent(isExpanded ? panel : false)
    }

    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'
    const isBargainsProject = global.storeConfigration?.bodyClass2?.value === 'bargainsClass'
    const isBuyBestProject = global.storeConfigration?.bodyClass2?.value === 'buyBestProject'
    return (
        <>
            <SEOTAG page="FAQ" />
            <Layout props={props}>
                <>
                    {isVarifiedGfTheme && !isBargainsProject && !isBuyBestProject ? (
                        <div className="px-5 py-4 stctPgWrpr faq">
                            <div
                                className="gfContactBanner mt-0"
                                // style="margin-top: 25px;margin-bottom: 25px;"
                            >
                                <h2 className="bannertext">
                                    <span>
                                        FAQ<small style={{ fontSize: '65%' }}>s</small>
                                    </span>
                                </h2>
                            </div>
                            <h2 style={h1Style}>Frequently Asked Questions</h2>
                            {/* <h4 style={h4Style}>Account & Registration</h4> */}
                            <div className="accorPareenDivision mt-5">
                                <Accordion
                                    expanded={expandedParent === 'panel1Header'}
                                    onChange={handleParentChange('panel1Header')}
                                    className="panelParentAccord"
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1Header-content"
                                        id="panel1Header-header"
                                        className="panelParentHeader"
                                    >
                                        <p className={classes.heading}>Account & Registration</p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div>
                                            <Accordion
                                                expanded={expanded === 'panel1'}
                                                onChange={handleChange('panel1')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1bh-content"
                                                    id="panel1bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: Do I have to register to bid?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: Yes, you must create an account with
                                                        Retail Rush before you can bid.
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel2'}
                                                onChange={handleChange('panel2')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel2bh-content"
                                                    id="panel2bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: How does registration work?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: In order to create an account, you must
                                                        complete the registration form, verify your
                                                        email, and then start bidding!
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel3'}
                                                onChange={handleChange('panel3')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel3bh-content"
                                                    id="panel3bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: How do I reset my password?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: Passwords can be reset either by going to
                                                        your account profile or by logging out and
                                                        selecting &#34;forgot password&#34; at the
                                                        login page. For a step-by-step guide, check
                                                        out our How It Works page.
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel20'}
                                                onChange={handleChange('panel20')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel3bh-content"
                                                    id="panel20bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: How do I update my address?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: You can update your contact and shipping
                                                        info anytime by visiting your Account
                                                        Settings. For a step-by-step guide, check
                                                        out our How It Works page.
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel21'}
                                                onChange={handleChange('panel21')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel3bh-content"
                                                    id="panel21bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: How do I update my payment information?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: You can update your contact and shipping
                                                        info anytime by visiting your Account
                                                        Settings. For a step-by-step guide, check
                                                        out our How It Works page.
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel22'}
                                                onChange={handleChange('panel22')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel3bh-content"
                                                    id="panel22bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: How do I update my payment information?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: You can update your contact and shipping
                                                        info anytime by visiting your Account
                                                        Settings. For a step-by-step guide, check
                                                        out our How It Works page.
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel23'}
                                                onChange={handleChange('panel23')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel3bh-content"
                                                    id="panel23bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: How do I contact customer service?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: You can reach out via email at
                                                        support@retailrush.com
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion
                                    expanded={expandedParent === 'panel2Header'}
                                    onChange={handleParentChange('panel2Header')}
                                    className="panelParentAccord"
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2Header-content"
                                        id="panel2Header-header"
                                        className="panelParentHeader"
                                    >
                                        <p className={classes.heading}>Payments & Billing</p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div>
                                            <Accordion
                                                expanded={expanded === 'panel4'}
                                                onChange={handleChange('panel4')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel4bh-content"
                                                    id="panel4bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: What payment methods do you accept?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: We accept all major credit and debit
                                                        cards—including Visa, Mastercard, American
                                                        Express, and Discover. You can also use
                                                        prepaid cards and digital wallet options if
                                                        supported by your card provider.
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel5'}
                                                onChange={handleChange('panel5')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel5bh-content"
                                                    id="panel5bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: Why is there a buyer&#34;s premium added
                                                        at checkout?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: A buyer’s premium is a small additional
                                                        fee added to the final sale price—this helps
                                                        us cover auction costs and continue
                                                        providing the best deals.
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel6'}
                                                onChange={handleChange('panel6')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel6bh-content"
                                                    id="panel6bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: What happens if my order becomes an
                                                        abandon order?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: If an order is abandoned, you’ll lose the
                                                        items you won, your account will be
                                                        temporarily locked, and a $150 fee will need
                                                        to be paid to reactivate bidding. Please
                                                        pickup during your 3 day window and make
                                                        sure your payment source is accurate to keep
                                                        your account in good standing.
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel7'}
                                                onChange={handleChange('panel7')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel7bh-content"
                                                    id="panel7bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: What is the Buyers Assurance?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: Buyers Assurance gives you peace of
                                                        mind—if something’s not right with your
                                                        winning item, you can return it for a refund
                                                        or store credit.
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion
                                    expanded={expandedParent === 'panel3Header'}
                                    onChange={handleParentChange('panel3Header')}
                                    className="panelParentAccord"
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel3Header-content"
                                        id="panel3Header-header"
                                        className="panelParentHeader"
                                    >
                                        <p className={classes.heading}>Bidding & Orders</p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div>
                                            <Accordion
                                                expanded={expanded === 'panel9'}
                                                onChange={handleChange('panel9')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel9bh-content"
                                                    id="panel9bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: Can I cancel a bid?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: Bids are final, so once placed, they
                                                        can’t be changed or canceled. Please
                                                        double-check before submitting!
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel10'}
                                                onChange={handleChange('panel10')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel10bh-content"
                                                    id="panel10bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: How do I know if I won an auction or not?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: You’ll get an email and/or text with the
                                                        exciting news and pickup details—get ready
                                                        to celebrate!
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel11'}
                                                onChange={handleChange('panel11')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel11bh-content"
                                                    id="panel11bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: Can I see the items in person before
                                                        bidding?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>A: No, all browsing is online only.</p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel12'}
                                                onChange={handleChange('panel12')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel12bh-content"
                                                    id="panel12bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: What are the conditions and where can I
                                                        locate them?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: You can find conditions on both the
                                                        product card and product page under the
                                                        title. These conditions are color coded
                                                        based on condition.
                                                    </p>
                                                    <h4>Like New:</h4>
                                                    <ul>
                                                        <li>· Product Condition: Factory Sealed</li>
                                                        <li>
                                                            · Description: The product is in perfect
                                                            condition, as if brand new and is
                                                            factory sealed.
                                                        </li>
                                                    </ul>
                                                    <h4>Open Box:</h4>
                                                    <ul>
                                                        <li>
                                                            · Product Condition: Not factory sealed,
                                                            may come in original packaging
                                                        </li>
                                                        <li>
                                                            · Description: The product has been
                                                            opened but shows no obvious signs of
                                                            use. Packaging may vary.
                                                        </li>
                                                    </ul>
                                                    <h4>Used:</h4>
                                                    <ul>
                                                        <li>
                                                            · Product Condition: May come in
                                                            original packaging but likely isn&#34;t
                                                        </li>
                                                        <li>
                                                            · Description: The product has
                                                            noticeable signs of use or damage.
                                                        </li>
                                                    </ul>
                                                    <h4>Uninspected Returns:</h4>
                                                    <ul>
                                                        <li>
                                                            · Product Condition: Not inspected for
                                                            quality or functionality
                                                        </li>
                                                        <li>
                                                            · Description: The product has been
                                                            hasn&#34;t been checked for condition or
                                                            working status.
                                                        </li>
                                                    </ul>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel13'}
                                                onChange={handleChange('panel13')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel13bh-content"
                                                    id="panel13bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: What if there is an issue with my order?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: We’re here to help! If something’s not
                                                        quite right with your order, please email us
                                                        at support@retailrush.com. To assist you as
                                                        quickly as possible, kindly include your
                                                        order number in your message.
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel14'}
                                                onChange={handleChange('panel14')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel14bh-content"
                                                    id="panel14bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: How Do I Cancel My Order?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: Orders can be cancelled reaching out to
                                                        customer support to initiate the
                                                        cancellation process. Remember, not all
                                                        orders qualify for cancellation so please
                                                        make sure to check out the policies page to
                                                        understand what qualifies.
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel24'}
                                                onChange={handleChange('panel24')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel14bh-content"
                                                    id="panel24bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: Where can I find my Wish List items?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: You can find your Wish List anytime by
                                                        clicking the Heart icon at the top right of
                                                        any page
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel25'}
                                                onChange={handleChange('panel25')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel14bh-content"
                                                    id="panel25bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: What&#34;s the difference between store
                                                        credit and a refund?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: Store credit is automatically applied to
                                                        your account and be used towards your next
                                                        winning bid. If you opt for a refund, you
                                                        will receive the money back on your original
                                                        payment method within 5-7 business days.
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel26'}
                                                onChange={handleChange('panel26')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel14bh-content"
                                                    id="panel26bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: What is Max Bid and how does it work?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: Max Bid makes bidding easy! You just set
                                                        the highest amount you&#34;re willing to pay
                                                        for an item, and we’ll automatically place
                                                        bids for you if someone else outbids you—up
                                                        to your max. It’s like having us do the
                                                        bidding so you don’t have to keep checking!
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel27'}
                                                onChange={handleChange('panel27')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel14bh-content"
                                                    id="panel27bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: What is Buy It Now?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: Buy It Now lets you skip the bidding and
                                                        grab an item instantly at a fixed price! If
                                                        you see this option on a product, you can
                                                        purchase it right away—no waiting, no
                                                        competing. Depending on the item, it can be
                                                        picked up in-store or shipped to you, based
                                                        on size and shipping availability.
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion
                                    expanded={expandedParent === 'panel4Header'}
                                    onChange={handleParentChange('panel4Header')}
                                    className="panelParentAccord"
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1Header-content"
                                        id="panel4Header-header"
                                        className="panelParentHeader"
                                    >
                                        <p className={classes.heading}>Pickup & Fulfillment</p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div>
                                            <Accordion
                                                expanded={expanded === 'panel15'}
                                                onChange={handleChange('panel15')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel15bh-content"
                                                    id="panel15bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: How does pickup work?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: Just bring your confirmation email (with
                                                        QR code) to the pickup location
                                                        listed—within 3 business days of the auction
                                                        closing. Our staff will scan your code,
                                                        guide you to your item, and direct you to
                                                        inspect it. Once you&#34;re done, they’ll
                                                        scan your code again to check you out.
                                                    </p>
                                                    <p>
                                                        Want a visual walkthrough? Visit our How It
                                                        Works page and watch the Pickup Process
                                                        video for step-by-step details!
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel16'}
                                                onChange={handleChange('panel16')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel16bh-content"
                                                    id="panel16bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: How many days do I have to pick up my
                                                        item?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: You have 3 business days from the date an
                                                        auction closes to pick up your item before
                                                        it becomes abandoned.
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel17'}
                                                onChange={handleChange('panel17')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel17bh-content"
                                                    id="panel17bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: What if I can&#34;t make my pickup days?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: That&#34;s okay, we get it - life is
                                                        busy. You can purchase Extended Pickup Hours
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel18'}
                                                onChange={handleChange('panel18')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel18bh-content"
                                                    id="panel18bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: Is there loading or assistance services
                                                        available at pickup?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: No, please bring help if needed—we do not
                                                        offer loading assistance.
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel19'}
                                                onChange={handleChange('panel19')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel19bh-content"
                                                    id="panel19bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: What if the item I won doesn&#34;t fit in
                                                        my car?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: Plan ahead: If there’s a chance your item
                                                        might not fit in your car, feel free to
                                                        bring someone with a larger vehicle or look
                                                        into a local hauling service to help with
                                                        transport
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel28'}
                                                onChange={handleChange('panel28')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel28bh-content"
                                                    id="panel28bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: Can someone else pick up for me?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: Yes! Just make sure they have your pickup
                                                        QR code—no code, no pickup. It’s the key to
                                                        a smooth handoff!
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel29'}
                                                onChange={handleChange('panel29')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel28bh-content"
                                                    id="panel29bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: Where do these items come from?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: Our items come from retail returns,
                                                        overstock, and unsold inventory from popular
                                                        big-box and online retailers—so you can
                                                        score top brands for less!
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel30'}
                                                onChange={handleChange('panel30')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel30bh-content"
                                                    id="panel30bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: What are your hours?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>Monday: Closed</p>
                                                    <p>Tuesday: 12pm - 7pm</p>
                                                    <p>Wednesday: 12pm - 7pm</p>
                                                    <p>Thursday: 12pm - 7pm</p>
                                                    <p>Friday: 12pm - 7pm</p>
                                                    <p>Saturday: 12am - 7pm</p>
                                                    <p>Sunday: Closed</p>
                                                    <p>*Holidays may effect these hours*</p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel31'}
                                                onChange={handleChange('panel31')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel31bh-content"
                                                    id="panel31bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: Do you ship?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: No, but that offering will be coming
                                                        soon!
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel32'}
                                                onChange={handleChange('panel32')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel32bh-content"
                                                    id="panel32bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: Where can I find all locations?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>A: Check out our About Us page!</p>
                                                </AccordionDetails>
                                            </Accordion>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion
                                    expanded={expandedParent === 'panel5Header'}
                                    onChange={handleParentChange('panel5Header')}
                                    className="panelParentAccord"
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel5Header-content"
                                        id="panel5Header-header"
                                        className="panelParentHeader"
                                    >
                                        <p className={classes.heading}>Loyalty & Rewards</p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div>
                                            <Accordion
                                                expanded={expanded === 'panel33'}
                                                onChange={handleChange('panel33')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel33bh-content"
                                                    id="panel33bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: How do referrals work?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: It’s easy! Share your referral code
                                                        (found in your profile). When a friend
                                                        registers and enters your referral code in
                                                        the allotted field, and places a bid, you
                                                        both get a $10 off coupon. Coupons expire in
                                                        3 months, so spread the word and keep
                                                        earning! Please note the person MUST enter
                                                        your code at registration AND place their
                                                        first bid before you receive credit.
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel34'}
                                                onChange={handleChange('panel34')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel34bh-content"
                                                    id="panel34bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: How long do I have to use my referral
                                                        credit?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: Referral credits are valid for 3 months
                                                        from the day they’re added to your
                                                        account—plenty of time to treat yourself!
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel35'}
                                                onChange={handleChange('panel35')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel35bh-content"
                                                    id="panel35bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: Can loyalty points expire?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>A: No, loyalty points don&#34;t expire.</p>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel36'}
                                                onChange={handleChange('panel36')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel36bh-content"
                                                    id="panel36bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: What can I use my Rush Points for?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>Rush Points Redemption:</p>
                                                    <ul>
                                                        <li>· Use 500 points for free shipping</li>
                                                        <li>
                                                            · Use 400 points to get extended pickup
                                                            days
                                                        </li>
                                                        <li>
                                                            · Use 200 points for a free item from
                                                            the Bin store
                                                        </li>
                                                        <li>
                                                            · Use 150 points for $5 coupon added at
                                                            checkout
                                                        </li>
                                                        <li>
                                                            · Use 75 points to get early access to
                                                            auction
                                                        </li>
                                                    </ul>
                                                </AccordionDetails>
                                            </Accordion>
                                            <Accordion
                                                expanded={expanded === 'panel37'}
                                                onChange={handleChange('panel37')}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel36bh-content"
                                                    id="panel36bh-header"
                                                >
                                                    <p className={classes.heading}>
                                                        Q: Where can I submit my videos, pictures or
                                                        reviews?
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <p>
                                                        A: For videos and pictures and a chance to
                                                        be featured on our social media, submit your
                                                        videos to community@retailrush.com. To leave
                                                        a google review, visit our Google Business
                                                        Page or click the button at the bottom of
                                                        your pickup confirmation email. You can also
                                                        check out our How It Works page for a
                                                        step-by-step tutorial on submitting reviews.
                                                    </p>
                                                </AccordionDetails>
                                            </Accordion>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            {/* <Accordion
                            expanded={expanded === 'panel8'}
                            onChange={handleChange('panel8')}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel8bh-content"
                                id="panel8bh-header"
                            >
                                <p className={classes.heading}>
                                    5. Why can&apos;t I access my account?
                                </p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <p>
                                    If you are a new bidder, please check your email and confirm the
                                    registration email that was sent. You may need to check your
                                    spam filter. Please contact us if you did not receive the
                                    registration email.
                                </p>
                            </AccordionDetails>
                        </Accordion> */}
                        </div>
                    ) : isBargainsProject || isBuyBestProject ? (
                        <div className="px-5 py-4 stctPgWrpr">
                            {/* <h2 className="text-center mb-3">About Us</h2> */}
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: global.storeDetails.terms,
                                }}
                            ></span>
                        </div>
                    ) : (
                        // <div className="staticContainer gFfaq">
                        //     <div className="header">
                        //         <h3>FAQ Page</h3>
                        //         <div className="date">Thursday, April 17, 2025 - 1:28 PM</div>
                        //     </div>

                        //     <div className="content">
                        //         <div className="section">
                        //             <h2 className="section-title">Account & Registration</h2>

                        //             <div className="faq-item">
                        //                 <div className="question">Q: Do I have to register to bid?</div>
                        //                 <div className="answer">
                        //                     A: Yes, you must create an account with Retail Rush before
                        //                     you can bid.
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">Q: How does registration work?</div>
                        //                 <div className="answer">
                        //                     A: In order to create an account, you must complete the{' '}
                        //                     <a href="https://www.allsurplus.com/account/register?landing=dealshome">
                        //                         registration
                        //                     </a>{' '}
                        //                     form, verify your email, and then start bidding!
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">Q: How do I reset my password?</div>
                        //                 <div className="answer">
                        //                     A: Passwords can be reset either by going to your account
                        //                     profile or by logging out and selecting &#39;forgot
                        //                     password&#39; at the login page. For a step-by-step guide,
                        //                     check out our
                        //                     <span className="italic">How It Works</span> page.
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">Q: How do I update my address?</div>
                        //                 <div className="answer">
                        //                     A: You can update your contact and shipping info anytime by
                        //                     visiting your Account Settings. For a step-by-step guide,
                        //                     check out our <span className="italic">How It Works</span>{' '}
                        //                     page.
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: How do I update my payment information?
                        //                 </div>
                        //                 <div className="answer">
                        //                     A: You can update your payment details anytime by heading to
                        //                     the Payment section in your Account Settings. Need help? Our{' '}
                        //                     <span className="italic">How It Works</span> page has a
                        //                     step-by-step guide to walk you through it.
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: How do I contact customer service?
                        //                 </div>
                        //                 <div className="answer">
                        //                     A: You can reach out via email at{' '}
                        //                     <a
                        //                         href="mailto:support@retailrush.com"
                        //                         className="email-link"
                        //                     >
                        //                         support@retailrush.com
                        //                     </a>
                        //                 </div>
                        //             </div>
                        //         </div>

                        //         <div className="section">
                        //             <h2 className="section-title">Payments & Billing</h2>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: What payment methods do you accept?
                        //                 </div>
                        //                 <div className="answer">
                        //                     A: We accept all major credit and debit cards—including
                        //                     Visa, Mastercard, American Express, and Discover. You can
                        //                     also use prepaid cards and digital wallet options if
                        //                     supported by your card provider.
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: Why is there a buyer&#39;s premium added at checkout?
                        //                 </div>
                        //                 <div className="answer">
                        //                     A: A buyer&#39;s premium is a small additional fee added to
                        //                     the final sale price—this helps us cover auction costs and
                        //                     continue providing the best deals.
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: What happens if my order becomes an abandon order?
                        //                 </div>
                        //                 <div className="answer">
                        //                     A: If an order is abandoned, you&#39;ll lose the items you
                        //                     won, your account will be temporarily locked, and a $150 fee
                        //                     will need to be paid to reactivate bidding. Please pickup
                        //                     during your 3 day window and make sure your payment source
                        //                     is accurate to keep your account in good standing.
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">Q: What is the Buyers Assurance?</div>
                        //                 <div className="answer">
                        //                     A: Buyers Assurance gives you peace of mind—if
                        //                     something&#39;s not right with your winning item, you can
                        //                     return it for a refund or store credit.
                        //                 </div>
                        //             </div>
                        //         </div>

                        //         <div className="section">
                        //             <h2 className="section-title">Bidding & Orders</h2>

                        //             <div className="faq-item">
                        //                 <div className="question">Q: Can I cancel a bid?</div>
                        //                 <div className="answer">
                        //                     A: Bids are final, so once placed, they can&#39;t be changed
                        //                     or canceled. Please double-check before submitting!
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: How do I know if I won an auction or not?
                        //                 </div>
                        //                 <div className="answer">
                        //                     A: You&#39;ll get an email{' '}
                        //                     <span className="italic">and/or</span> text with the
                        //                     exciting news and pickup details—get ready to celebrate!
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: Can I see the items in person before bidding?
                        //                 </div>
                        //                 <div className="answer">
                        //                     A: No, all browsing is online only.
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: What are the conditions and where can I locate them?
                        //                 </div>
                        //                 <div className="answer">
                        //                     A: You can find conditions on both the product card and
                        //                     product page under the title. These conditions are color
                        //                     coded based on condition.
                        //                     <div className="condition-list">
                        //                         <div className="condition-item">
                        //                             <div className="condition-title">Like New:</div>
                        //                             <div className="condition-detail">
                        //                                 <strong>Product Condition:</strong> Factory
                        //                                 Sealed
                        //                                 <br />
                        //                                 <strong>Description:</strong> The product is in
                        //                                 perfect condition, as if brand new and is
                        //                                 factory sealed.
                        //                             </div>
                        //                         </div>

                        //                         <div className="condition-item">
                        //                             <div className="condition-title">Open Box:</div>
                        //                             <div className="condition-detail">
                        //                                 <strong>Product Condition:</strong> Not factory
                        //                                 sealed, may come in original packaging
                        //                                 <br />
                        //                                 <strong>Description:</strong> The product has
                        //                                 been opened but shows no obvious signs of use.
                        //                                 Packaging may vary.
                        //                             </div>
                        //                         </div>

                        //                         <div className="condition-item">
                        //                             <div className="condition-title">Used:</div>
                        //                             <div className="condition-detail">
                        //                                 <strong>Product Condition:</strong> May come in
                        //                                 original packaging but likely isn&#39;t
                        //                                 <br />
                        //                                 <strong>Description:</strong> The product has
                        //                                 noticeable signs of use or damage.
                        //                             </div>
                        //                         </div>

                        //                         <div className="condition-item">
                        //                             <div className="condition-title">
                        //                                 Uninspected Returns:
                        //                             </div>
                        //                             <div className="condition-detail">
                        //                                 <strong>Product Condition:</strong> Not
                        //                                 inspected for quality or functionality
                        //                                 <br />
                        //                                 <strong>Description:</strong> The product has
                        //                                 been hasn&#39;t been checked for condition or
                        //                                 working status.
                        //                             </div>
                        //                         </div>
                        //                     </div>
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: What if there is an issue with my order?
                        //                 </div>
                        //                 <div className="answer">
                        //                     A: We&#39;re here to help! If something&#39;s not quite
                        //                     right with your order, please email us at{' '}
                        //                     <a
                        //                         href="mailto:support@retailrush.com"
                        //                         className="email-link"
                        //                     >
                        //                         support@retailrush.com
                        //                     </a>
                        //                     . To assist you as quickly as possible, kindly include your
                        //                     order number in your message.
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">Q: How Do I Cancel My Order?</div>
                        //                 <div className="answer">
                        //                     A: Orders can be cancelled reaching out to customer support
                        //                     to initiate the cancellation process. Remember, not all
                        //                     orders qualify for cancellation so please make sure to check
                        //                     out the policies page to understand what qualifies.
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: Where can I find my Wish List items?
                        //                 </div>
                        //                 <div className="answer">
                        //                     A: You can find your Wish List anytime by clicking the Heart
                        //                     icon at the top right of any page
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: What&#39;s the difference between store credit and a
                        //                     refund?
                        //                 </div>
                        //                 <div className="answer">
                        //                     A: Store credit is automatically applied to your account and
                        //                     be used towards your next winning bid. If you opt for a
                        //                     refund, you will receive the money back on your original
                        //                     payment method within 5-7 business days.
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: What is Max Bid and how does it work?
                        //                 </div>
                        //                 <div className="answer">
                        //                     A: Max Bid makes bidding easy! You just set the highest
                        //                     amount you&#39;re willing to pay for an item, and we&#39;ll
                        //                     automatically place bids for you if someone else outbids
                        //                     you—up to your max. It&#39;s like having us do the bidding
                        //                     so you don&#39;t have to keep checking!
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">Q: What is Buy It Now?</div>
                        //                 <div className="answer">
                        //                     A: Buy It Now lets you skip the bidding and grab an item
                        //                     instantly at a fixed price! If you see this option on a
                        //                     product, you can purchase it right away—no waiting, no
                        //                     competing. Depending on the item, it can be picked up
                        //                     in-store or shipped to you, based on size and shipping
                        //                     availability.
                        //                 </div>
                        //             </div>
                        //         </div>

                        //         <div className="section">
                        //             <h2 className="section-title">Pickup & Fulfillment</h2>

                        //             <div className="faq-item">
                        //                 <div className="question">Q: How does pickup work?</div>
                        //                 <div className="answer">
                        //                     A: Just bring your confirmation email (with QR code) to the
                        //                     pickup location listed—within 3 business days of the auction
                        //                     closing. Our staff will scan your code, guide you to your
                        //                     item, and direct you to inspect it. Once you&#39;re done,
                        //                     they&#39;ll scan your code again to check you out.
                        //                     <br />
                        //                     <br />
                        //                     Want a visual walkthrough? Visit our{' '}
                        //                     <span className="italic">How It Works</span> page and watch
                        //                     the Pickup Process video for step-by-step details!
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: How many days do I have to pick up my item?
                        //                 </div>
                        //                 <div className="answer">
                        //                     A: You have 3 business days from the date an auction closes
                        //                     to pick up your item before it becomes abandoned.
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: What if I can&#39;t make my pickup days?
                        //                 </div>
                        //                 <div className="answer">
                        //                     A: That&#39;s okay, we get it - life is busy. You can
                        //                     purchase Extended Pickup Hours
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: Is there loading or assistance services available at
                        //                     pickup?
                        //                 </div>
                        //                 <div className="answer">
                        //                     A: No, please bring help if needed—we do not offer loading
                        //                     assistance.
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: What if the item I won doesn&#39;t fit in my car?
                        //                 </div>
                        //                 <div className="answer">
                        //                     A: Plan ahead: If there&#39;s a chance your item might not
                        //                     fit in your car, feel free to bring someone with a larger
                        //                     vehicle or look into a local hauling service to help with
                        //                     transport
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: Can someone else pick up for me?
                        //                 </div>
                        //                 <div className="answer">
                        //                     A: Yes! Just make sure they have your pickup QR code—no
                        //                     code, no pickup. It&#39;s the key to a smooth handoff!
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: Where do these items come from?
                        //                 </div>
                        //                 <div className="answer">
                        //                     A: Our items come from retail returns, overstock, and unsold
                        //                     inventory from popular big-box and online retailers—so you
                        //                     can score top brands for less!
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">Q: What are your hours?</div>
                        //                 <div className="answer">
                        //                     <div className="hours-table">
                        //                         <div className="hours-row">
                        //                             <span>Monday:</span>
                        //                             <span>Closed</span>
                        //                         </div>
                        //                         <div className="hours-row">
                        //                             <span>Tuesday:</span>
                        //                             <span>12pm - 7pm</span>
                        //                         </div>
                        //                         <div className="hours-row">
                        //                             <span>Wednesday:</span>
                        //                             <span>12pm - 7pm</span>
                        //                         </div>
                        //                         <div className="hours-row">
                        //                             <span>Thursday:</span>
                        //                             <span>12pm - 7pm</span>
                        //                         </div>
                        //                         <div className="hours-row">
                        //                             <span>Friday:</span>
                        //                             <span>12pm - 7pm</span>
                        //                         </div>
                        //                         <div className="hours-row">
                        //                             <span>Saturday:</span>
                        //                             <span>10am - 7pm</span>
                        //                         </div>
                        //                         <div className="hours-row">
                        //                             <span>Sunday:</span>
                        //                             <span>Closed</span>
                        //                         </div>
                        //                     </div>
                        //                     <br />
                        //                     <span className="italic">
                        //                         *Holidays may affect these hours*
                        //                     </span>
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">Q: Do you ship?</div>
                        //                 <div className="answer">
                        //                     A: No, but that offering will be coming soon!
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: Where can I find all locations?
                        //                 </div>
                        //                 <div className="answer">A: Check out our About Us page!</div>
                        //             </div>
                        //         </div>

                        //         <div className="section">
                        //             <h2 className="section-title">Loyalty & Rewards</h2>

                        //             <div className="faq-item">
                        //                 <div className="question">Q: How do referrals work?</div>
                        //                 <div className="answer">
                        //                     A: It&#39;s easy! Share your referral code (found in your
                        //                     profile). When a friend registers and enters your referral
                        //                     code in the allotted field, and places a bid, you{' '}
                        //                     <span className="italic">both</span> get a $10 off coupon.
                        //                     Coupons expire in 3 months, so spread the word and keep
                        //                     earning!{' '}
                        //                     <strong>
                        //                         <span className="italic">
                        //                             Please note the person MUST enter your code at
                        //                             registration AND place their first bid before you
                        //                             receive credit.
                        //                         </span>
                        //                     </strong>
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: How long do I have to use my referral credit?
                        //                 </div>
                        //                 <div className="answer">
                        //                     A: Referral credits are valid for 3 months from the day
                        //                     they&#39;re added to your account—plenty of time to treat
                        //                     yourself!
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">Q: Can loyalty points expire?</div>
                        //                 <div className="answer">
                        //                     A: No, loyalty points don&#39;t expire.
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: What can I use my Rush Points for?
                        //                 </div>
                        //                 <div className="answer">
                        //                     <span className="underline">Rush Points Redemption:</span>
                        //                     <div className="points-list">
                        //                         <div className="points-item">
                        //                             • Use 500 points for free shipping
                        //                         </div>
                        //                         <div className="points-item">
                        //                             • Use 400 points to get extended pickup days
                        //                         </div>
                        //                         <div className="points-item">
                        //                             • Use 200 points for a free item from the Bin store
                        //                         </div>
                        //                         <div className="points-item">
                        //                             • Use 150 points for $5 coupon added at checkout
                        //                         </div>
                        //                         <div className="points-item">
                        //                             • Use 75 points to get early access to auction
                        //                         </div>
                        //                     </div>
                        //                 </div>
                        //             </div>

                        //             <div className="faq-item">
                        //                 <div className="question">
                        //                     Q: Where can I submit my videos, pictures or reviews?
                        //                 </div>
                        //                 <div className="answer">
                        //                     A: For videos and pictures and a chance to be featured on
                        //                     our social media, submit your videos to{' '}
                        //                     <a
                        //                         href="mailto:community@retailrush.com"
                        //                         className="email-link"
                        //                     >
                        //                         community@retailrush.com
                        //                     </a>
                        //                     . To leave a google review, visit our{' '}
                        //                     <a href="http://www.googlebusinesspage.com">
                        //                         Google Business Page
                        //                     </a>{' '}
                        //                     or click the button at the bottom of your pickup
                        //                     confirmation email. You can also check out our How It Works
                        //                     page for a step-by-step tutorial on submitting reviews.
                        //                 </div>
                        //             </div>
                        //         </div>
                        //     </div>
                        // </div>
                        <div className="px-5 py-4 stctPgWrpr faq">
                            <h1 style={h1Style}>FAQs</h1>
                            <h4 style={h4Style}>General FAQs</h4>
                            <Accordion
                                expanded={expanded === 'panel1'}
                                onChange={handleChange('panel1')}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1bh-content"
                                    id="panel1bh-header"
                                >
                                    <p className={classes.heading}>
                                        1. What type of product(s) can I buy from Lots of Auctions?
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>
                                        Lots of Auctions offers a large selection of merchandise
                                        from a wide range of categories. Available categories can be
                                        viewed by location in the dropdown menu at the top of our
                                        website. Interested bidders can view available lot(s) in
                                        each auction by clicking &ldquo;BID NOW&ldquo; on the
                                        auction.
                                    </p>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                expanded={expanded === 'panel2'}
                                onChange={handleChange('panel2')}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2bh-content"
                                    id="panel2bh-header"
                                >
                                    <p className={classes.heading}>
                                        2. What is the condition of the product?
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>
                                        The lots offered through our online auctions include shelf
                                        pulls, overstock, and customer returns. The description for
                                        each lot will state if the item is brand new.
                                    </p>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                expanded={expanded === 'panel3'}
                                onChange={handleChange('panel3')}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel3bh-content"
                                    id="panel3bh-header"
                                >
                                    <p className={classes.heading}>
                                        3. Can I buy a vehicle from Lots of Auctions?
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>
                                        We&apos;re sorry, Lots of Auctions does not offer cars,
                                        trucks, or other vehicles for sale through our online
                                        auctions at this time.
                                    </p>
                                </AccordionDetails>
                            </Accordion>
                            <h4 style={h4Style}>Website FAQs</h4>
                            <Accordion
                                expanded={expanded === 'panel4'}
                                onChange={handleChange('panel4')}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel4bh-content"
                                    id="panel4bh-header"
                                >
                                    <p className={classes.heading}>
                                        1. How do I view auctions by location?
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>
                                        You can view all of our auctions on the homepage of our
                                        website or by clicking the links on our live auction page.
                                    </p>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                expanded={expanded === 'panel5'}
                                onChange={handleChange('panel5')}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel5bh-content"
                                    id="panel5bh-header"
                                >
                                    <p className={classes.heading}>
                                        2.How do I view available lot(s) in each auction?
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>
                                        You can view all available lot(s) by clicking the &ldquo;BID
                                        NOW&ldquo; button under the description on each auction.
                                        Please note: clicking &ldquo;BID NOW&ldquo; on our website
                                        does not automatically enter a bid on the auction.
                                    </p>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                expanded={expanded === 'panel6'}
                                onChange={handleChange('panel6')}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel6bh-content"
                                    id="panel6bh-header"
                                >
                                    <p className={classes.heading}>
                                        3. Where are your auctions located?
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>
                                        We currently offer online auctions in Denton, TX and Dallas,
                                        TX. We will add additional locations in the future. Please
                                        check back often. You can view our auction locations by
                                        clicking https://lotsofauctions.com/live-auctions/
                                    </p>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                expanded={expanded === 'panel7'}
                                onChange={handleChange('panel7')}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel7bh-content"
                                    id="panel7bh-header"
                                >
                                    <p className={classes.heading}>4. How does the auction work?</p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>
                                        After registering to bid and confirming your account,
                                        bidders can click &ldquo;BID NOW&ldquo; to view all
                                        available lots in each auction. Bidders can place bids on
                                        any lot(s) they choose. There is no limit to bidding.
                                        Bidders may choose to place a &ldquo;Quick Bid&ldquo; or
                                        submit a highest bid on each lot. The system sends
                                        notification when bidders get outbid. At this time, the
                                        bidder may choose to increase their bid or forfeit the
                                        auction. Winning bidders will r eceive notification once
                                        they win the auction. Following the auction, winning bidders
                                        must pick-up their lot(s) from the location listed on the
                                        auction(s). Additional information about bidding can be
                                        found in the Bidder FAQ section below.
                                    </p>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                expanded={expanded === 'panel8'}
                                onChange={handleChange('panel8')}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel8bh-content"
                                    id="panel8bh-header"
                                >
                                    <p className={classes.heading}>
                                        5. Why can&apos;t I access my account?
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>
                                        If you are a new bidder, please check your email and confirm
                                        the registration email that was sent. You may need to check
                                        your spam filter. Please contact us if you did not receive
                                        the registration email.
                                    </p>
                                </AccordionDetails>
                            </Accordion>
                            <h4 style={h4Style}>Bidding FAQ – Lots</h4>
                            <Accordion
                                expanded={expanded === 'panel9'}
                                onChange={handleChange('panel9')}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel9bh-content"
                                    id="panel9bh-header"
                                >
                                    <p className={classes.heading}>
                                        1.What&apos;s the difference between pallets & individual
                                        items?
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>
                                        Pallets are pre-built and contain a selection of products.
                                        These pallets contain up to 15-20% fallout (unusable
                                        products). Our pallets are an excellent option for resellers
                                        and open-air market vendors that require lots of product.
                                        Individual items are sold separately. It is recommended that
                                        everyday shoppers bid on our individual items, not
                                        pallets.Pallets are pre-built and contain a selection of
                                        products. These pallets contain up to 15-20% fallout
                                        (unusable products). Our pallets are an excellent option for
                                        resellers and open-air market vendors that require lots of
                                        product. Individual items are sold separately. It is
                                        recommended that everyday shoppers bid on our individual
                                        items, not pallets.
                                    </p>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                expanded={expanded === 'panel10'}
                                onChange={handleChange('panel10')}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel10bh-content"
                                    id="panel10bh-header"
                                >
                                    <p className={classes.heading}>
                                        2. Can I pick the items included on my pallet?
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>
                                        No. The pallets available through our pallet auction are
                                        pre-built. Winning bidders accept all items on the pallet at
                                        purchase.
                                    </p>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                expanded={expanded === 'panel11'}
                                onChange={handleChange('panel11')}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel11bh-content"
                                    id="panel11bh-header"
                                >
                                    <p className={classes.heading}>
                                        3. Is there a fall-out guarantee?
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>
                                        The pallets included in our pallet auctions include a 15-20%
                                        fallout guarantee. Fallout refers to
                                        damaged/missing/non-functional product.
                                    </p>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                expanded={expanded === 'panel12'}
                                onChange={handleChange('panel12')}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel12bh-content"
                                    id="panel12bh-header"
                                >
                                    <p className={classes.heading}>
                                        4. What is the return policy for pallets?
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>
                                        Winning bidders will have an opportunity to inspect their
                                        pallet(s) on-site before breakdown and removal. Pallet(s)
                                        that do not meet the winning bidders satisfaction can be
                                        returned for a refund immediately following on-site
                                        inspection.
                                    </p>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                expanded={expanded === 'panel13'}
                                onChange={handleChange('panel13')}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel13bh-content"
                                    id="panel13bh-header"
                                >
                                    <p className={classes.heading}>
                                        5. How do I pay for the pallet(s) I win?
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>
                                        Please visit our Terms of Use for details about payment.
                                        Full payment from the winning bidder must be received prior
                                        to the removal or transportation of purchased pallets.
                                    </p>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                expanded={expanded === 'panel14'}
                                onChange={handleChange('panel14')}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel14bh-content"
                                    id="panel14bh-header"
                                >
                                    <p className={classes.heading}>
                                        6. How do I get the pallet(s) I win?
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>
                                        Winning bidders must pick-up their pallet(s) within the
                                        pick-up window posted on the auction. Lots of Auctions
                                        offers convenient contact-less pick-up in Texas. Please
                                        contact us for information about shipping items outside of
                                        the area.
                                    </p>
                                </AccordionDetails>
                            </Accordion>
                            <h4 style={h4Style}>Selling FAQ</h4>
                            <Accordion
                                expanded={expanded === 'panel15'}
                                onChange={handleChange('panel15')}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel15bh-content"
                                    id="panel15bh-header"
                                >
                                    <p className={classes.heading}>
                                        1. How do I register to sell with Lots of Auctions?
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>
                                        Interested parties can apply to sell by filling out the form
                                        located here. Applying to sell with Lots of Auctions is fast
                                        and easy!
                                    </p>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                expanded={expanded === 'panel16'}
                                onChange={handleChange('panel16')}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel16bh-content"
                                    id="panel16bh-header"
                                >
                                    <p className={classes.heading}>
                                        2. What happens after I apply to sell?
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>
                                        After applying to sell with Lots of Auctions, one of our
                                        representatives will review your information and contact you
                                        directly to discuss next steps. Please note: you will not be
                                        able to log-in to list your lot(s) immediately after
                                        applying to sell.
                                    </p>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                expanded={expanded === 'panel17'}
                                onChange={handleChange('panel17')}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel17bh-content"
                                    id="panel17bh-header"
                                >
                                    <p className={classes.heading}>
                                        3. Can I sell through Lots of Auctions if I live outside the
                                        United States?
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>
                                        At this time we only accept sellers located within the
                                        United States.
                                    </p>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                expanded={expanded === 'panel18'}
                                onChange={handleChange('panel18')}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel18bh-content"
                                    id="panel18bh-header"
                                >
                                    <p className={classes.heading}>
                                        4. Why should I sell my lot(s) at auction?
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>
                                        Our sellers choose to sell their lot(s) through our online
                                        auctions for a number of reasons. Businesses may sell to
                                        reduce inventory or earn extra revenue on the side. Online
                                        auctions increase visibility and allow resellers, business
                                        owners, and entrepreneurs to reach a high number of
                                        interested buyers fast.
                                    </p>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                expanded={expanded === 'panel19'}
                                onChange={handleChange('panel19')}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel19bh-content"
                                    id="panel19bh-header"
                                >
                                    <p className={classes.heading}>5.Why Lots of Auctions?</p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>
                                        Lots of Auctions uses targeted advertising to ensure the
                                        right people see our auctions. In addition to increasing the
                                        number of people that view our listings, this also helps our
                                        sellers get top dollar for their items. We offer convenient
                                        and free registration for bidders.
                                    </p>
                                </AccordionDetails>
                            </Accordion>
                            {/* <span
                        dangerouslySetInnerHTML={{
                            __html: global.storeDetails.terms,
                        }}
                    ></span> */}
                        </div>
                    )}
                </>
            </Layout>
        </>
    )
}
